import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["documentableId"]

  connect() {
    // Initialize the controller
  }

  updateDocumentableId(event) {
    const selectedType = event.target.value
    const documentableIdSelect = this.element.closest('form').querySelector('select[name="service_request_master[documentable_id]"]')
    
    if (documentableIdSelect && selectedType) {
      // Fetch available documents based on selected type
      fetch(`/api/${selectedType.toLowerCase()}s`)
        .then(response => response.json())
        .then(data => {
          // Clear and update options
          documentableIdSelect.innerHTML = '<option value="">Select document</option>'
          data.forEach(item => {
            const option = new Option(item.name || `#${item.id}`, item.id)
            documentableIdSelect.add(option)
          })
        })
        .catch(error => {
          console.error('Error fetching documents:', error)
        })
    } else if (documentableIdSelect) {
      // Clear options if no type selected
      documentableIdSelect.innerHTML = '<option value="">Select document</option>'
    }
  }
} 